<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ id > 0 ? "Editar" : "Adicionar" }} Iniciativas
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Nome"
              name="tipo"
              type="text"
              v-model="iniciativa.nomeIniciativa"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <ComboboxTerritoriosCategorias
              :value="iniciativa"
              ref="eixos"
              :rules="rules"
              :disabled="id > 0"
            ></ComboboxTerritoriosCategorias>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição detalhada"
              name="tipo"
              type="text"
              v-model="iniciativa.descricao"
              :rules="rules"
              background-color="white"
            />
          </v-col>

          <v-col>
            <div>Iniciativa Própria?</div>
            <v-radio-group
              v-model="iniciativa.propria"
              row
              :rules="requiredBoolean"
            >
              <v-radio label="Sim" :key="1" :value="true"></v-radio>
              <v-radio label="Não" :key="2" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import ComboboxTerritoriosCategorias from "@/modules/gestao-territorios/components/categorias/ComboboxTerritoriosCategorias";
import { territorioIniciativaAPI } from "@/modules/gestao-territorios/API/territorioIniciativaAPI";
import { required, requiredBoolean } from "@/helpers/validator";

export default {
  components: {
    ComboboxTerritoriosCategorias,
  },
  data() {
    return {
      iniciativa: { propria: 2 },
      isEdit: false,
      tabType: this.$route.params.tab,
      id: this.$route.params.id,
      rules: [required],
      requiredBoolean: [requiredBoolean],
    };
  },
  mounted() {
    if (this.id > 0) {
      this.setLoading(true);
      territorioIniciativaAPI
        .get(this.id)
        .then(({ data }) => {
          this.iniciativa = data;
          this.iniciativa.territorioCategoria =
            this.iniciativa.territorioCategoriaId;
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Iniciativa");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(`/gestao-territorios/${this.tabType}`);
    },
    async onSubmit() {
      const valid = await this.check();
      if (!valid) return;

      let iniciativas = {
        ...this.iniciativa,
        territorioCategoriaId: this.iniciativa.territorioCategoria,
      };

      if (this.id > 0) {
        this.setLoading(true);
        if (!valid) return;

        territorioIniciativaAPI
          .update(iniciativas)
          .then(() => {
            this.$notification.success("Governança editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Governança");
            console.log("Erro no submit ", err);
          });
      } else {
        this.setLoading(true);
        const eixosvalid = await this.$refs.eixos.check();
        if (!valid || !eixosvalid) return;

        territorioIniciativaAPI
          .create(iniciativas)
          .then(() => {
            this.$notification.success("Governança criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Governança");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      const eixoValid = await this.$refs.eixos.check();
      return isValid && eixoValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
